import { FormType } from "../selections";

import { Component } from "vue";
import GeneralForm from "@/components/forms/GeneralForm.vue";
import MPRNForm from "@/components/forms/MPRNForm.vue";
import BERForm from "@/components/forms/BERForm.vue";
import GeneralFormUK from "@/components/forms/GeneralFormUK.vue";
import AddressForm from "@/components/forms/AddressForm.vue";
import DwellingForm from "@/components/forms/DwellingForm.vue";

export const FORM_COMPONENT_DICT = new Map<FormType, Component>([
  [FormType.TypicalHome, GeneralForm],
  [FormType.MPRN, MPRNForm],
  [FormType.BER, BERForm],
  [FormType.TypicalHomeUK, GeneralFormUK],
  [FormType.Address, AddressForm],
  [FormType.DwellingUpload, DwellingForm],
]);


export const FORM_LABEL_DICT = new Map([
  [FormType.TypicalHome, "typicalIrishHomes"],
  [FormType.MPRN, "useMPRN"],
  [FormType.BER, "useBER"],
  [FormType.TypicalHomeUK, "typicalHomeUK"],
  [FormType.Address, "address"],
  [FormType.DwellingUpload, "dwellingUpload"],
]);

export const FORM_ACCURACY_DICT = new Map([
  [FormType.TypicalHome, "typicalIrishHomes"],
  [FormType.MPRN, "useMPRN"],
  [FormType.BER, "useBER"]
]);
